import React, { Suspense } from 'react'
import PublicPageLoader from '../../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../../helper/lazyWithRetry'

const RegistrationCompany = lazyWithRetry(() => import(/* webpackChunkName: "company" */'../../../component/Registration/Company'))

const RegistrationCompanyPage = React.memo(() => {
	return (
		<Suspense fallback={<PublicPageLoader className="authPage" />}>
			<RegistrationCompany />
		</Suspense>
	)
})

RegistrationCompanyPage.displayName = 'RegistrationCompanyPage'
export default RegistrationCompanyPage
